export default {
      id: "file-pdf-regular-usage",
      viewBox: "0 0 384 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#file-pdf-regular",
      toString: function () {
        return this.url;
      }
    }